export {ProductColor} from './productColor';
export {ProductColorImp} from './productColor.imp';
